import { ReactNode } from 'react';
import { Grid } from '@material-ui/core';
import {
  EntityAboutCard,
  EntityHasSubcomponentsCard,
  EntityLinksCard,
  EntitySwitch,
  isKind
} from '@backstage/plugin-catalog'
import { defaultEntityWarningContent } from './EntityWarningContent';
import {
  DependabotAlertsWidget,
  SecurityInsightsWidget
} from '@roadiehq/backstage-plugin-security-insights';
import { GithubIssuesCard } from '@backstage-community/plugin-github-issues';
import {
  EntityRecentGithubActionsRunsCard,
  isGithubActionsAvailable
} from '@backstage-community/plugin-github-actions';
import {
  EntityGithubDeploymentsCard,
  isGithubDeploymentsAvailable
} from '@backstage-community/plugin-github-deployments';
import {
  EntityGithubPullRequestsOverviewCard,
  isGithubPullRequestsAvailable
} from '@roadiehq/backstage-plugin-github-pull-requests';
import {
  EntityGithubInsightsLanguagesCard,
  EntityGithubInsightsReadmeCard,
  EntityGithubInsightsReleasesCard,
  isGithubInsightsAvailable
} from '@roadiehq/backstage-plugin-github-insights';
import {
  ArgocdDeploymentSummary,
  isArgocdConfigured
} from '@backstage-community/plugin-argocd/legacy'
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { hasLinks } from './hasLinks';
import {
  isGitHubDependabotAvailable,
  isGitHubIssuesAvailable,
  isGitHubSecurityInsightsAvailable
} from '../../utils';

export type OverviewContentProps = {
  additionalCard?: React.JSX.Element;
  entityWarningContent?: ReactNode;
};
export const overviewContent = (props?: OverviewContentProps) => {
  return (
    <Grid container spacing={3} alignItems="stretch">
      {props?.entityWarningContent ?? defaultEntityWarningContent}
      <Grid item md={6}>
        <EntityAboutCard />
      </Grid>

      <EntitySwitch>
        <EntitySwitch.Case if={isGitHubDependabotAvailable}>
          <Grid item md={6}>
            <DependabotAlertsWidget />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>

      <EntitySwitch>
        <EntitySwitch.Case if={isGitHubSecurityInsightsAvailable}>
          <Grid item md={6}>
            <SecurityInsightsWidget/>
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>
      
      <EntitySwitch>
        <EntitySwitch.Case if={isGitHubIssuesAvailable}>
          <Grid item md={6}>
            <GithubIssuesCard itemsPerPage={2} />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>
      <EntitySwitch>
        <EntitySwitch.Case if={isGithubActionsAvailable}>
          <Grid item md={6} >
            <EntityRecentGithubActionsRunsCard />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>

      <EntitySwitch>
        <EntitySwitch.Case if={isGithubPullRequestsAvailable}>
          <Grid item md={6} >
            <EntityGithubPullRequestsOverviewCard />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>

      <EntitySwitch>
        <EntitySwitch.Case if={isGithubDeploymentsAvailable}>
          <Grid item md={6}>
            <EntityGithubDeploymentsCard />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>

      <EntitySwitch>
        <EntitySwitch.Case if={e => Boolean(isArgocdConfigured(e))}>
          <Grid item md={12} xl={6} >
            <ArgocdDeploymentSummary />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>

      <EntitySwitch>
        <EntitySwitch.Case if={isGithubInsightsAvailable}>
          <Grid item md={6}>
            <EntityGithubInsightsReadmeCard maxHeight={568} />
          </Grid>
          <Grid item md={6}>
            <EntityGithubInsightsLanguagesCard />
            <EntityGithubInsightsReleasesCard />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>

      <EntitySwitch>
        <EntitySwitch.Case if={hasLinks}>
          <Grid item sm={12} md={6}>
            <EntityLinksCard />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>

      {props?.additionalCard}

      <Grid item md={12} lg={6}>
        <EntityCatalogGraphCard height={400} />
      </Grid>

      <EntitySwitch>
        <EntitySwitch.Case if={e => !isKind('resource')(e)}>
          <Grid item md={12} lg={6}>
            <EntityHasSubcomponentsCard />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>
    </Grid>

  );
};
